module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-Italic-1377011147dc7f32ea31c2c09120e067.woff";